import StandardTabPanel from "../../../../../components/ui library/components/tab-panels/standard/StandardTabPanel";
import { TAB_STYLES } from "../../../../ui library/components/tab-panels/standard/tab-header/tab-styles";

export default function Navigation({ _case, activeTab, children }) {
  const allTabs = [
    {
      key: "providers",
      name: "Providers",
      isDisabled: false,
      permission: null,
      href: `/client-detail/${_case.id}/medical/providers`,
    },
    {
      key: "appointments",
      name: "Appointments",
      isDisabled: false,
      permission: null,
      href: `/client-detail/${_case.id}/medical/appointments`,
    },
    {
      key: "injuries",
      name: "Injuries",
      isDisabled: false,
      permission: null,
      href: `/client-detail/${_case.id}/medical/injuries`,
    },
    {
      key: "referrals",
      name: "Referrals",
      isDisabled: false,
      permission: null,
      href: `/client-detail/${_case.id}/medical/referrals`,
    },
    {
      key: "health-insurance",
      name: "Health Insurance",
      isDisabled: true,
      permission: null,
      href: `/client-detail/${_case.id}/medical/health-insurance`,
    },
  ];

  return (
    <StandardTabPanel
      activeTab={activeTab}
      tabList={allTabs}
      headerTabSx={TAB_STYLES.SUB_TAB.SX}
      headerTabIndicatorSx={TAB_STYLES.SUB_TAB.TAB_INDICATOR_SX}
    >
      <section className="min-h-[90vh] p-4">{children}</section>
    </StandardTabPanel>
  );
}
